class NewsletterBox extends HTMLElement {
  isOpen = false;

  constructor() {
    super();

    this.config = JSON.parse(this.querySelector('script').innerHTML);
    this.container = this.querySelector('.Newsletter__Container');
    this.closeIcons = this.querySelectorAll('.Action__Close');
    this.goToCartButton = this.querySelector('.Action-Submit');

    if (this.config.presaleProducts.length > 0) {
      document.body.addEventListener('submit', (event) => {
        if (event.target.tagName !== 'FORM') {
          return;
        }

        if (event.target.action.endsWith('/cart') === false) {
          return;
        }

        event.preventDefault();

        if (fbq) {
          fbq('track', 'InitiateCheckout', {
            currency: this.config.currency,
            content_type: this.config.content_type,
            num_items: this.config.num_items,
            value: this.config.value,
            content_ids: this.config.lineItems.map((lineItem) => lineItem.product_id),
          });
        }

        this.show();
      });

      this.closeIcons.forEach((closer) => {
        closer.addEventListener('click', this.hide.bind(this));
      });

      this.goToCartButton.addEventListener('click', this.continueToCart.bind(this));
    }
  }

  show() {
    this.container.classList.add('Newsletter__Container--active');
  }

  hide() {
    this.container.classList.remove('Newsletter__Container--active');
  }

  continueToCart() {
    this.goToCartButton.classList.add('loading');
    fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        updates: Object.values(this.config.presaleProducts).reduce(
          (acc, item) => ({
            ...acc,
            [item.lineId.trim()]: 0,
          }),
          {}
        ),
      }),
    })
      .then(() => {
        window.location.href = '/checkout';
      })
      .finally(() => {
        this.goToCartButton.classList.remove('loading');
      });
  }
}

window.customElements.define('newsletter-box', NewsletterBox);
